import { render, staticRenderFns } from "./FruitStateG.vue?vue&type=template&id=787e7fc5"
import script from "./FruitStateG.vue?vue&type=script&lang=js"
export * from "./FruitStateG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports